import { render } from "./reset_link_sent.html?vue&type=template&id=3806b2e9&external"
import script from "./reset_link_sent.js?vue&type=script&lang=js&external"
export * from "./reset_link_sent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__